import React from 'react'
import Button from '@material-ui/core/Button';
import { useRedirect } from 'react-admin';

const cancelButtonStyle = { marginLeft: '20px', marginRight: '20px', borderRadius: '5px', backgroundColor: 'lightGray' }

const CancelButton = (props) => {
    const redirectTo = useRedirect();
    let rPath = ''

    if (props.record && props.record.id) rPath = `${props.basePath}/${props.record.id}/show`
    else rPath = `${props.basePath}`

    const handleRedirect = () => {
        try {
            if (props.history) {
                props.history.goBack()
            } else redirectTo(rPath)
        } catch (e) {
            console.warn(e)
        }
    }
    return (
        <div >
            <Button onClick={handleRedirect} style={cancelButtonStyle}>Cancel</Button>
        </div>
    )

}

export default CancelButton